<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      single-expand
    >
    <template v-slot:condition>
      <v-col cols="12" md='2' class="pr-2 pl-0 px-1" v-if="!$isMobile">
        <v-select
          :items="[{ text: 'Version_1.0', value: 1 },{ text: 'Version_2.0', value: 2 },{ text: 'Version_3.0', value: 3 }]"
          label="合同版本"
          v-model="item.params.version"
          hide-details='auto'
          outlined dense
          clearable
          @change="loadData"
        ></v-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-n1 pt-c-10 px-0">
        <base-marerial-user-select  @on-change="loadData" label='创建人员' hide-details outlined dense v-model="item.params.uids" :menu='$constants.SysMenu.INVOICE_M_ID'></base-marerial-user-select>
      </v-col>
    </template>
    <template v-slot:foot="{ total, loading }">
      <td :colspan="item.headers.length" :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
        <div class="my-3 mx-4" v-if="!loading">
          合计开票：<span :class="`${$isMobile ? 'size-20': 'size-27'} blue--text font-family-Impact`">{{total === null ? 0 : total.invoiced}}</span>&nbsp;<br v-if="$isMobile">
          审核中：<span :class="`${$isMobile ? 'size-20': 'size-27'} orange--text font-family-Impact`">{{total === null ? 0 : total.autiding}}</span>&nbsp;
          审核未通过：<span :class="`${$isMobile ? 'size-20': 'size-27'} red--text font-family-Impact`">{{total === null ? 0 : total.noPass}}</span>&nbsp;<br v-if="$isMobile">
          实际开票：<span :class="`${$isMobile ? 'size-20': 'size-27'} green--text font-family-Impact`">{{total === null ? 0 : total.geted}}</span>&nbsp;
        </div>
        <div v-else class="my-3 mx-4 red--text">合计数据查询中...</div>
      </td>
    </template>
    <template v-slot:expanded-content="{ headers, item, refresh }">
      <td :colspan="headers.length" v-if='refresh' class="px-0">
        <v-divider v-if="$isMobile"></v-divider>
        <v-tabs v-model="tab">
          <v-tab>发票详情</v-tab>
          <v-tab>合同详情</v-tab>
          <v-tab v-for="(rel, idx) in item.relationInvoiceInfos" :key="idx" v-if="rel.id !== item.id">
              关联发票({{`00${idx+1}`}})
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <detail-view mini show-mail :item='item | formatObjectToArray'></detail-view>
          </v-tab-item>
          <v-tab-item>
            <contract-view mini :item='item.contract' lazy></contract-view>
          </v-tab-item>
          <v-tab-item v-for="(rel, idx) in item.relationInvoiceInfos" :key="idx" v-if="rel.id !== item.id">
            <detail-view mini show-mail :item='rel | formatObjectToArray'></detail-view>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>
    </base-material-table>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { fmAuditColor } from '@/utils/stringUtil.js'
  import { receive } from '@/api/contract/invoice.js'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import DetailView from './components/Detail.vue'

  export default {
    name: 'ContractInvoice',
    components: {
      DetailView,
      ContractView
    },
    data() {
      return {
        tab: '',
        signItems: [],
        invoiceReceiveTypeItems: [],
        item: {
          mobile: true,
          total: true,
          path: 'contract/invoice/info/list',
          topButtons: [
            { event: 'search', show: true }
          ],
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          params: {
            version: '',
            uids: []
          },
          headers: [
             {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              width: 200,
              mobile: true,
              value: 'customer.name',
              sortable: false,
              copy: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '创建人员',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              width: 120,
              sortable: false
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 200,
              mobile: true,
              value: 'contract.serialNumber',
              sortable: false,
              copy: true,
              search: { type: 'input' }
            },
            {
              text: '审核状态',
              align: 'center',
              divider: true,
              width: 120,
              value: 'order',
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => fmAuditColor(val.auditStatus),
                formatter: (val) => val.auditStatusVal
              },
              search: {
                mobile: true,
                type: 'select',
                secKey: 'auditStatus',
                multiple: true,
                model: [0, 1],
                options: () => [
                  { label: '审核中', value: 0 },
                  { label: '已通过', value: 1 },
                  { label: '未通过', value: -1 }
                ]
              }
            },
            {
              text: '发票编号',
              align: 'center',
              divider: true,
              width: 120,
              mobile: true,
              value: 'invoiceNumber',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '抬头名称',
              align: 'center',
              divider: true,
              width: 180,
              value: 'address.customerName',
              sortable: false
            },
            {
              text: '发票类型',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'address.headType',
              sortable: false,
              formatter: (val) => (val === 1 ? '个人' : '企业')
            },
            {
              text: '开票金额',
              align: 'center',
              divider: true,
              width: 120,
              value: 'money',
              mobile: true,
              sortable: false
            },
            {
              text: '开票时间',
              align: 'center',
              divider: true,
              width: 120,
              value: 'writeTime',
              sortable: false,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD'),
              search: {
                type: 'date',
                range: true,
                multiple: true,
                secKey: 'writeTimes'
              }
            },
            {
              text: '开票公司',
              align: 'center',
              divider: true,
              width: 200,
              value: 'contract.signDic.name',
              sortable: false,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'signId',
                options: () => this.signItems
              },
            },
            {
              text: '领取状态',
              align: 'center',
              divider: true,
              width: 100,
              value: 'receive',
              sortable: false,
              mobile: true,
              formatter: (val) => (val === 0 ? '未领取' : '已领取'),
              search: {
                type: 'select',
                secKey: 'receive',
                options: () => [
                  { label: '未领取', value: 0 },
                  { label: '已领取', value: 1 },
                ]
              }
            },
            {
              text: '领取时间',
              align: 'center',
              divider: true,
              width: 120,
              value: 'receiveTime',
              sortable: false,
              mobile: true,
              formatter: (val) => val == null ? '--' : this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '领取人',
              align: 'center',
              divider: true,
              width: 120,
              value: 'receiveUser',
              sortable: false,
              formatter: (val) => val == null ? '--' : val.name
            },
            {
              text: '发票类型',
              align: 'center',
              divider: true,
              width: 160,
              value: 'typeDic.name',
              sortable: false
            },
            {
              text: '关联发票',
              align: 'center',
              divider: true,
              width: 120,
              value: 'relationNumber',
              sortable: false,
              formatter: (val) => `+${val}`
            },
            {
              text: '费用内容',
              align: 'center',
              divider: true,
              width: 200,
              value: 'moneyTypeDic.name',
              mobile: true,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              width: 110,
              sortable: false,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '作废',
                    color: 'warning',
                    icon: 'mdi-delete',
                    onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                    disable: (row) => !this.$_has('con-contract-invoice-delete') || row.order.auditStatus !== 1 || row.receive === 1
                  },
                  {
                    text: '领取',
                    color: 'green',
                    icon: 'mdi-attachment-check',
                    onClick: (row) => this.receive(row.id, row.customer.name, null),
                    disable: (row) => !this.$_has('con-contract-invoice-delete') || row.order.auditStatus !== 1 || row.receive === 1
                  },
                  {
                    text: '下载',
                    color: 'blue',
                    icon: 'mdi-download-circle-outline',
                    onClick: (row) => this.receive(row.id, row.customer.name, row.filePath),
                    disable: (row) => !this.$_has('con-contract-invoice-delete') || row.order.auditStatus !== 1 || !row.fileName
                  }
                ]
              }
            }
          ]
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.table.loadData()
      },
      view (filePath) {
        if (filePath) {
          window.open(
            filePath,
            "_blank"
          );
        }
      },
      receive (id, customerName, filePath) {
        this.$dialog.confirm({
          text: `确认领取(<span class="red--text">${customerName}</span>)的发票吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                receive({ id }).then(response => {
                  if (response.status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`操作成功`, { position: 'top-right', timeout: 4000 })
                    this.view(filePath)
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.contractSignPid,
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.contractSignPid === result.id) {
                this_.signItems = result.data
              }
            })
          }
        })
      }
    },
    created () {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
